import { render, staticRenderFns } from "./budget-definitions.vue?vue&type=template&id=787d505e&"
import script from "./budget-definitions.vue?vue&type=script&lang=js&"
export * from "./budget-definitions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports